import { notificationApi } from '../helpers/axios';

export const notificationsApi = {
	registrationToken: (payload: { person_id: number; firebase_client_token: string; app_id: string }) =>
		notificationApi.post(`/person_notification_settings/push_register`, payload),
};
